<template>
    <v-app>
      <v-app-bar app>
        <Header/>
      </v-app-bar> 
        <v-container fluid >        
          <v-row class="py-4">
            <v-col cols="12">
              <subHeader/>
            </v-col>
            <v-col cols="12">
              <router-view name='homePage'></router-view>              
            </v-col>
          </v-row> 
        </v-container> 
    </v-app>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header'
import subHeader from '@/components/parentsModule/subHeader'
// import mainPage from '@/components/mainPage'
export default {
  name: 'Home',
  components: {
    Header,
    subHeader
    // mainPage
  }
}
</script>
